import { MouseSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core'

const activationConstraint = {
  distance: 1,
}

export const useDragAndDropSettings = () => {
  const sensors = useSensors(
    useSensor(MouseSensor, { activationConstraint }),
    useSensor(TouchSensor, { activationConstraint }),
  )

  return { sensors }
}
